export const defaultLineItems = [
  {
    id: 'production',
    title: 'Production',
    description: 'Location filming and production',
    quantity: 1,
    unitPrice: 2050
  },
  {
    id: 'post-production',
    title: 'Post-Production',
    description: 'Editing, colour grading, audio mix, graphics and delivery',
    quantity: 1,
    unitPrice: 1250
  },
  {
    id: 'music-licensing',
    title: 'Music Licensing',
    description: 'Professional music licensing for the agreed production and usage',
    quantity: 1,
    unitPrice: 150
  }
];

export function lineItemTotal(item) {
  return Number(item.quantity || 0) * Number(item.unitPrice || 0);
}

export function formatLineItemPrice(amount) {
  return new Intl.NumberFormat('en-AU', {
    style: 'currency',
    currency: 'AUD',
    maximumFractionDigits: 2
  }).format(amount);
}